"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
require("react-native-get-random-values");
const uuid_1 = require("uuid");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const Toast_styles_1 = require("./Toast.styles");
const ToastUI_1 = __importDefault(require("./ToastUI"));
const types_1 = require("./types");
const { width } = react_native_1.Dimensions.get('window');
class Toast extends react_1.Component {
    constructor(props) {
        super(props);
        this.show = (message, toastOptions) => {
            const id = toastOptions?.id || uuid_1.v4().toString();
            const onDestroy = () => {
                const { toasts } = this.state;
                if (toastOptions?.onClose) {
                    toastOptions?.onClose();
                }
                this.setState({ toasts: toasts.filter((t) => t.id !== id) });
            };
            const onHide = () => {
                this.hide(id);
            };
            requestAnimationFrame(() => {
                const { toasts } = this.state;
                this.setState({
                    toasts: [
                        {
                            id,
                            onDestroy,
                            message,
                            open: true,
                            placement: types_1.ToastPlacement.TOP,
                            onHide,
                            // @ts-ignore
                            ...this.props,
                            ...toastOptions,
                        },
                        ...toasts.filter((t) => t.open),
                    ],
                });
            });
            return id;
        };
        this.hide = (id) => {
            const { toasts } = this.state;
            this.setState({
                toasts: toasts.map((t) => (t.id === id ? { ...t, open: false } : t)),
            });
        };
        this.isOpen = (id) => {
            const { toasts } = this.state;
            return toasts.some((t) => t.id === id && t.open);
        };
        this.state = {
            toasts: [],
        };
    }
    renderBottomToasts(bottomSafeAreaInset) {
        const { toasts } = this.state;
        // eslint-disable-next-line react/destructuring-assignment
        const offsetFromFooter = this.props.offsetTop || 8;
        const style = {
            bottom: bottomSafeAreaInset + offsetFromFooter,
            width,
            justifyContent: 'flex-end',
            flexDirection: 'column',
        };
        return (react_1.default.createElement(react_native_1.KeyboardAvoidingView, { behavior: react_native_1.Platform.OS === 'ios' ? 'position' : undefined, style: [Toast_styles_1.toastContainerStyles.container, style], pointerEvents: "box-none" }, toasts
            .filter((t) => !t.placement || t.placement === types_1.ToastPlacement.BOTTOM)
            .map((toast) => (react_1.default.createElement(ToastUI_1.default, Object.assign({ key: toast.id }, toast))))));
    }
    renderTopToasts(topSafeAreaInset) {
        const { toasts } = this.state;
        // eslint-disable-next-line react/destructuring-assignment
        const offsetFromHeader = this.props.offsetTop || 8;
        const headerHeight = react_native_1.Platform.OS === 'ios' ? 44 : 56;
        const style = {
            top: topSafeAreaInset + headerHeight + offsetFromHeader,
            width,
            justifyContent: 'flex-start',
            flexDirection: 'column-reverse',
        };
        return (react_1.default.createElement(react_native_1.KeyboardAvoidingView, { behavior: react_native_1.Platform.OS === 'ios' ? 'position' : undefined, style: [Toast_styles_1.toastContainerStyles.container, style], pointerEvents: "box-none" }, toasts
            .filter((t) => t.placement === types_1.ToastPlacement.TOP)
            .map((toast) => (react_1.default.createElement(ToastUI_1.default, Object.assign({ key: toast.id }, toast))))));
    }
    render() {
        return (react_1.default.createElement(react_native_safe_area_context_1.SafeAreaInsetsContext.Consumer, null, (insets) => (react_1.default.createElement(react_1.default.Fragment, null,
            this.renderTopToasts(insets.top),
            this.renderBottomToasts(insets.bottom)))));
    }
}
exports.default = Toast;
